<template>
  <div>
    <!-- <div class="ui info message" style="display: block">
      <div class="header">{{ $t("hints") }}</div>
      <ul class="list">
        <li
          v-html="$t('the key is to verify incoming tokens and should match')"
        ></li>
      </ul>
    </div> -->
    <div class="ui form">
      <div class="two fields">
        <!-- <div class="field">
          <label for>{{ $t("key") }}</label>
          <input type="text" name="key" v-model="key" />
        </div>
        <div class="field">
          <label for>{{ $t("token name") }}</label>
          <input type="text" name="name" v-model="name" />
        </div> -->
      </div>
    </div>
  </div>
</template>

<script>
import { isEmpty } from "lodash";
import {
  // error_toast,
  // local_api,
  enterprise_setup,
} from "@/utils";
// import moment from "moment";
import filters from "@/filters";

export default {
  name: "DynamicJwtAuthentication",
  filters: filters,
  components: {},
  props: {
    endpoint_in: Object,
  },
  computed: {
    enterprise_setup() {
      return enterprise_setup(this);
    },
  },
  data() {
    return {
      key: "",
      name: "",
      // validity_time: "7d",
    };
  },
  methods: {
    getData() {
      return {
        key: this.key,
        name: this.name,
        validity_time: this.validity_time,
      };
    },
  },
  mounted() {
    let vm = this;
    if (!isEmpty(vm.endpoint_in)) {
      vm.key = vm.endpoint_in.setup.security.jwt_key || "modul";
      vm.name = vm.endpoint_in.setup.security.jwt_token_name || "my-t";
    }
  },
  created() {},
  watch: {},
  updated: function() {},
};
</script>
